module.exports = __webpack_public_path__ + "img/arrow-right.b6ec1c4c.svg";